import React from "react";
import Modal, {
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,

} from "../../../../components/bootstrap/Modal";
import Label from "../../../../components/bootstrap/forms/Label";
import Textarea from "../../../../components/bootstrap/forms/Textarea";
import Button from "../../../../components/bootstrap/Button";

type Candidate = {
    name?: string;
    email?: string;
};

type RejectItem = {
    candidate?: Candidate;
};

type RejectCandidateModalProps = {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    rejectItem: RejectItem | null;
    feedback: string;
    setFeedback: React.Dispatch<React.SetStateAction<string>>;
    handleRejectCandidate: (feedback: string) => void;
};

const RejectCandidateModal: React.FC<RejectCandidateModalProps> = ({
    isOpen,
    setIsOpen,
    rejectItem,
    feedback,
    setFeedback,
    handleRejectCandidate,
}) => {
    function capitalizeWords(str: string | undefined): string {
        if (!str) return '';
        return str
            .toLowerCase()
            .split(' ')
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
    return (
        <Modal isCentered isOpen={isOpen} setIsOpen={setIsOpen}>
            <ModalHeader
                style={{
                    background: "linear-gradient(90deg, #f87171, #fca5a5)",
                    color: "#fff",
                    borderTopLeftRadius: "0.5rem",
                    borderTopRightRadius: "0.5rem",
                    padding: "1.5rem",
                }}
            >
                <ModalTitle
                    id="reject-candidate"
                    style={{ fontWeight: "bold", fontSize: "1.4rem" }}
                >
                    Reject Candidate
                </ModalTitle>
            </ModalHeader>

            <ModalBody
                className="bg-dark"
                style={{
                    padding: "2rem",
                    borderBottomLeftRadius: "0.5rem",
                    borderBottomRightRadius: "0.5rem",
                }}
            >
                {/* Candidate Info */}
                <div
                    className="d-flex align-items-center gap-3 bg-dark rounded border mb-4 px-3 py-2 shadow-sm"

                >
                    <div
                        style={{
                            width: "42px",
                            height: "42px",
                            borderRadius: "50%",
                            backgroundColor: "#e3342f",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            fontSize: "1.1rem",
                            textTransform: "uppercase",
                        }}
                    >
                        {rejectItem?.candidate?.name?.[0] || "C"}
                    </div>
                    <div>
                        <h6 className="mb-1 fw-bold text-light">
                            {capitalizeWords(rejectItem?.candidate?.name)}
                        </h6>
                        <small className="text-muted">
                            {rejectItem?.candidate?.email}
                        </small>
                    </div>
                </div>

                {/* Feedback Section */}
                <div className="mb-3">
                    <Label htmlFor="feedback" className="form-label fw-semibold text-start">
                        Feedback <small className="text-muted">(optional)</small>
                    </Label>
                    <Textarea
                        id="feedback"
                        className="form-control shadow-sm"
                        rows={4}
                        placeholder={`Share your thoughts about ${rejectItem?.candidate?.name}...`}
                        value={feedback}
                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                            setFeedback(e.target.value)
                        }
                        style={{ resize: "none", fontSize: "0.95rem" }}
                    />
                    {feedback.length > 500 && (
                        <small className="text-danger d-block mt-1">
                            Feedback must be 500 characters or fewer.
                        </small>
                    )}

                    {/* Info & Counter */}
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <small className="text-muted">
                            This feedback will be recorded with the status.
                        </small>
                        <small
                            className={
                                feedback.length >= 500 ? "text-danger" : "text-muted"
                            }
                        >
                            {feedback.length} / 500
                        </small>
                    </div>

                    {/* Progress */}
                    <div className="progress mt-2" style={{ height: "6px" }}>
                        <div
                            className={`progress-bar ${feedback.length < 450 ? "bg-secondary" : "bg-danger"
                                }`}
                            style={{
                                width: `${Math.min((feedback.length / 500) * 100, 100)}%`,
                            }}
                        />
                    </div>
                </div>
            </ModalBody>

            {/* Footer */}
            <ModalFooter
                style={{
                    padding: "1.25rem 2rem",
                    borderBottomLeftRadius: "0.5rem",
                    borderBottomRightRadius: "0.5rem",
                }}
                className="d-flex justify-content-between gap-3 bg-dark"
            >
                <Button
                    color="light"
                    className="py-2 fw-semibold bg-dark text-light"
                    style={{
                        borderRadius: "0.5rem",
                        width: "45%",
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                    }}
                    onClick={() => setIsOpen(false)}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                    }}
                >
                    Cancel
                </Button>

                <Button
                    color="danger"
                    className="py-2 fw-semibold text-white"
                    isDisable={feedback.length > 500}
                    style={{
                        borderRadius: "0.5rem",
                        width: "45%",
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                    }}
                    onClick={() => handleRejectCandidate(feedback)}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                    }}
                >
                    Reject
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default RejectCandidateModal;
